module.exports = __webpack_public_path__ + "static/media/share-square.1e2beef7.svg";